<template>
    <div class="space-y-6">
        <div class="grid grid-cols-2 gap-4">
            <div class="grid grid-cols-2 gap-4">
                <DsTextarea
                    v-model="textareaValue"
                    label="Textarea"
                />

                <DsTextarea
                    v-model="textareaValue"
                    helperText="With helper text"
                    label="Textarea"
                />

                <DsTextarea
                    v-model="textareaValue"
                    helperText="Required"
                    label="Textarea"
                    labelTooltip="Info icon tooltip"
                    required
                />

                <DsTextarea
                    v-model="textareaValue"
                    helperText="With info icon"
                    label="Textarea"
                    labelTooltip="Info icon tooltip"
                />

                <DsTextarea
                    v-model="textareaValue"
                    label="With custom rows"
                    :rows="2"
                />

                <DsTextarea
                    v-model="textareaValue"
                    label="Non-resizable"
                    :resizable="false"
                />

                <DsTextarea
                    v-model="textareaValue"
                    error="Error message"
                    label="Textarea"
                />
                <DsTextarea
                    v-model="textareaValue"
                    :error="true"
                    label="Textarea"
                >
                    <template #error>A slotted error message</template>
                </DsTextarea>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsTextarea from '@ds/form/input/text/DsTextarea.vue';
import { ref } from 'vue';

const textareaValue = ref('Textarea sample');
</script>
